module.exports = __webpack_public_path__ + "static/media/ENGProjectPrevieww935@1x.4219bdb0.jpg";